import React, {FC} from 'react';
import {AnimatePresence, m} from 'framer-motion';

import {Button} from '@zoefin/design-system';

import {AUTO_ADVANCE_STEPS} from '../../constants';
import {useFhs, useFhsActor} from '../../store/FhsContext/hooks';

import styles from './styles.module.scss';

const FADE_DURATION = 0.22;

// Bottom-fixed navigation for the FHS form. The first step (name) keeps its
// "Start Here" button inline below the input
const StepNavigation: FC = () => {
  const actor = useFhsActor();
  const {stepName, canContinue, isFirst, isLast} = useFhs();

  if (isFirst || isLast) return null;

  const isAutoAdvance = AUTO_ADVANCE_STEPS.has(stepName);

  return (
    <div className={styles.stepNavigation}>
      <m.button
        type="button"
        className={styles.stepNavigation__back}
        onClick={() => actor.send({type: 'BACK'})}
        aria-label="Go back to previous question"
        initial={{opacity: 0, scale: 0.92}}
        animate={{opacity: 1, scale: 1}}
        transition={{duration: FADE_DURATION}}>
        <i className="fa-light fa-chevron-left" aria-hidden />
      </m.button>

      <AnimatePresence mode="wait">
        {!isAutoAdvance && (
          <m.div
            key="continue"
            className={styles.stepNavigation__continueWrap}
            initial={{opacity: 0, y: 8}}
            animate={{opacity: 1, y: 0}}
            exit={{opacity: 0, y: 8}}
            transition={{duration: FADE_DURATION}}>
            <Button
              as="button"
              size="large"
              disabled={!canContinue}
              onClick={() => actor.send({type: 'NEXT'})}
              className={styles.stepNavigation__continue}>
              Continue
            </Button>
          </m.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default StepNavigation;
